import React, { useState } from 'react';

import Grid from '@mui/material/Grid2';

import {
  ModelBase,
} from "@models";
import {
  RuleDefinition,
  RULE_TAG_VALUES,
  isRuleTag,
} from "@dndModels";

import API from "@utilities/smart_api";
import CommonUtilities from "@utilities/common_utilities";

import ModelBaseInput from "@dndComponents/ModelBaseInput";
import SelectObjectBox from "@components/input/selects/SelectObjectBoxSimple";
import SelectStringBox from "@components/input/selects/SelectStringBox";

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

interface Props {
  obj?: ModelBase;
}

export default function RuleDefinitionEdit({ obj: param_obj }: Props) {
  const [obj, setObj] = useState<RuleDefinition>(param_obj instanceof RuleDefinition ? param_obj : api.applyWorkingOn(new RuleDefinition()));
  const [change_time, setChangeTime] = useState(0);

  const disabled = api.user === null || !api.online || (!api.user.admin && obj._id !== "" && obj.owner_id !== api.user._id);

  const updateObj = (updater: (o: RuleDefinition) => void) => {
    const new_obj = obj.clone(); // clone, don't mutate
    updater(new_obj);
    setObj(new_obj);
    setChangeTime(common_util.get_time_number());
  };

  return (
    <ModelBaseInput
      obj={obj}
      disabled={disabled}
      change_time={change_time}
      onChange={(changed: ModelBase) => {
        if (changed instanceof RuleDefinition) {
          const new_obj = obj;
          new_obj.copy(changed);
          setObj(new_obj);
          setChangeTime(common_util.get_time_number());
        }
      }}>
      <Grid container spacing={0} direction="row">
        <Grid size={4}>
          <SelectStringBox
            name="Tag"
            options={[...RULE_TAG_VALUES]}
            value={obj.rule_tag}
            disabled={disabled}
            onChange={(changed: string) => updateObj(o => { o.rule_tag = isRuleTag(changed) ? changed : "None"; })}
          />
        </Grid>
        <Grid size={8}>
          <SelectObjectBox
            name="See Also"
            data_type="rule_definition"
            values={obj.see_also_ids}
            multiple
            disabled={disabled}
            onChange={(changed: string[]) => updateObj(o => { o.see_also_ids = changed.filter(id => id !== o._id); })}
          />
        </Grid>
      </Grid>
    </ModelBaseInput>
  );
}
